import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  confirmData: any;
  comments:string='';
  @ViewChild('commentsModel') commentsModel;
  submitted:boolean=false;
  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onCloseDialog () : void  {
    this.dialogRef.close({ event: 'cancel' });
  }
  onDelete(event) {
    event.preventDefault();
    this.submitted = true;
    if (this.commentsModel.invalid) {
      return false;
    }
    this.dialogRef.close({ event: 'confirm',notes:this.comments });
  }

}
